<script setup lang="ts">
import { twMerge, type ClassNameValue } from 'tailwind-merge';

const props = defineProps<{
  title?: string;
  class?: ClassNameValue;
}>();
</script>

<template>
  <h1
    :class="twMerge(
      'text-4xl font-bold text-primary tracking-tight font-karma',
      props.class,
    )"
  >
    <slot>
      {{ title }}
    </slot>
  </h1>
</template>
